<script lang="ts">
    import Link from "svelte-link";
    import { href,} from "../../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
    import { Image } from "sveltestrap";
    export let rows
    let imgPath:string = "/assets/images/product";
</script>

{#if rows}
  {#each $rows as row}
    <tr>
      <td>
        <Link {href}>
          <Image fluid class="img-30" src="{imgPath}/{row.img}" alt="#" />
        </Link>
      </td>
      <td>
        <div class="product-name">
          <Link {href}>{row.name}</Link>
          <div class="order-process">
            <span class={row.class} />{row.status}
          </div>
        </div>
      </td>
      <td>{row.size}</td>
      <td>{row.color}</td>
      <td>{row.number}</td>
      <td>{row.units}</td>
      <td>{row.price}</td>
      <td><FeatherIcon icon="more-vertical" /></td>
    </tr>
  {/each}
{/if}
